// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grigo-assistant-ui-poc-panel {
  --background: #ffffff;
  --foreground: #0f172a;
  --muted: #f4f4f5;
  --muted-foreground: #64748b;
  --border: #e4e4e7;
  --radius: 0.5rem;
}

.grigo-assistant-ui-thread-viewport {
  max-height: 14rem;
  overflow-y: auto;
  padding: 0.5rem 0.75rem 0.75rem;
}

.grigo-assistant-ui-msg {
  margin-bottom: 0.5rem;
  font-size: 13px;
  line-height: 1.5;
  border-radius: 0.5rem;
  padding: 0.5rem 0.65rem;
}

.grigo-assistant-ui-msg-user {
  background: #f4f4f5;
  color: #0f172a;
  margin-left: 1.5rem;
}

.grigo-assistant-ui-msg-assistant {
  background: #e0f1f8;
  color: #0f172a;
  margin-right: 1.5rem;
}

.grigo-assistant-ui-composer-hidden {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/modules/end-user/chat/components/assistant-ui-poc/grigo-assistant-ui-thread-poc.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf","sourcesContent":[".grigo-assistant-ui-poc-panel {\n  --background: #ffffff;\n  --foreground: #0f172a;\n  --muted: #f4f4f5;\n  --muted-foreground: #64748b;\n  --border: #e4e4e7;\n  --radius: 0.5rem;\n}\n\n.grigo-assistant-ui-thread-viewport {\n  max-height: 14rem;\n  overflow-y: auto;\n  padding: 0.5rem 0.75rem 0.75rem;\n}\n\n.grigo-assistant-ui-msg {\n  margin-bottom: 0.5rem;\n  font-size: 13px;\n  line-height: 1.5;\n  border-radius: 0.5rem;\n  padding: 0.5rem 0.65rem;\n}\n\n.grigo-assistant-ui-msg-user {\n  background: #f4f4f5;\n  color: #0f172a;\n  margin-left: 1.5rem;\n}\n\n.grigo-assistant-ui-msg-assistant {\n  background: #e0f1f8;\n  color: #0f172a;\n  margin-right: 1.5rem;\n}\n\n.grigo-assistant-ui-composer-hidden {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
